// extracted by mini-css-extract-plugin
export default {"container":"cShRlyJtyjll5cZg0WLC","content":"NBWmluRQNl5EJGGlQdUm","message":"G2bJ4sG79bV672NyyLqU","cta":"_7fNFxZ7LF3E7bjA1XXc"};